export default __webpack_public_path__ + "static/image6-a1e9393f916eb234b9e68566a1a02a5b.jpg";